<template>
  <div v-show="show" class="mask">
    <div class="dialog">
      <div class="title">
        <span>订单支付</span>
        <a style="cursor: pointer;padding: 20px 20px 20px 20px" @click="closeShow">X</a>
      </div>
      <div class="content">

        <div class="tip">
          <img style="width: 4%;margin:0 3%" src="../assets/make/public/tip-icon.png">
          <span style="font-size: 12px;color:#35315C" >提示：支付后请勿关闭网页！</span>
        </div>

        <div class="item">
          <div class="item-label">应付金额</div>
          <div class="item-content">
            <div class="price">￥{{(payInfo.pay_fee/100).toFixed(2)}}</div>
          </div>
        </div>
        <div class="item">
          <div class="item-label">支付方式</div>
          <div class="item-content">
            <div @click="wxClick" style="margin-right: 10px" :class="payWay==='wx'?'pay-way-btn-active':'pay-way-btn'">
              <img style="width:90px" src="../assets/make/public/pay_icon_wechat.png">
              <img v-show="payWay==='wx'"  style="width: 20px;position: absolute;bottom: 0;right: 0" src="../assets/make/public/selected_payway.png">
            </div>

            <div @click="zfbClick" :class="payWay==='zfb'?'pay-way-btn-active':'pay-way-btn'">
              <img style="width:90px" src="../assets/make/public/pay_icon_zfb.png">
              <img v-show="payWay==='zfb'" style="width: 20px;position: absolute;bottom: 0;right: 0" src="../assets/make/public/selected_payway.png">
            </div>
          </div>
        </div>
        <div class="item">
          <div class="item-label"></div>
          <div style="display: flex;align-items: center;flex-direction: column">
            <div ref="payCode" id="payCode" style="width: 200px;height: 200px;padding: 10px;border: 1px solid rgba(53,49,92,0.2);border-radius: 4px">
            </div>
            <div style="width: 200px;display: flex;align-items: center;justify-content: space-between;margin-top: 5px">
              <div style="background-image: linear-gradient(to right,#ffffff,#35315C);width: 60px;height: 1px;opacity: 0.4"></div>
              <img src="../assets/make/public/pay_icon_scan.png" style="width: 14px">
              <span style="font-size: 12px;color: rgba(53,49,92,0.4)">扫码支付</span>
              <div style="background-image: linear-gradient(to right,#35315C,#ffffff);width: 60px;height: 1px;opacity: 0.4"></div>
            </div>
          </div>

        </div>

      </div>


    </div>

  </div>
</template>

<script>
  import api from "../makeOnlineApi/api";
  import QRCode from "qrcodejs2";
    export default {
        name: "PayDialog",
        props:{
            payInfo:{
                require:true
            },
            show:{
                require: true
            }
        },

        watch:{
            show:function (newProps) {
                if (newProps){
                    this.wxClick()
                    this.pollingTimer=-1
                }


            },

        },
        data(){
            return{
                payWay:'',
                pollingTimer:-1,
                qrcode:null,
            }
        },

        methods:{
            closeShow(){
                // close是在父组件on监听的方法
                // 第二个参数是需要传的值
                this.$emit('close', false)
                this.pollingTimer>-1&&clearInterval(this.pollingTimer)

            },

            wxClick(){
                if (this.payWay!=='wx'){
                    this.payWay='wx'
                    api.getWxPayQrCode(this.payInfo.order_id).then((res)=>{
                        this.creatQrCode(res.data.result.code_url)
                    })
                }

            },

            zfbClick(){
                if (this.payWay!=='zfb'){
                    this.payWay='zfb'
                    api.getZfbPayQrCode(this.payInfo.order_id).then((res)=>{
                        this.creatQrCode(res.data.result.code_url)
                    })
                }

            },
            creatQrCode(url) {

                if (!this.qrcode){
                    this.qrcode = new QRCode("payCode", {
                        width: 200, // 二维码宽度，单位像
                        height: 200, // 二维码高度，单位像素
                    });
                }
                this.qrcode.makeCode(url)
                this.pollingOrderState()
            },

            // 轮询 查询订单状态来判断支付状态
            pollingOrderState(){
                let func = () =>{
                    api.getOrderState(this.payInfo.order_id).then(res=>{
                        if (res.data.pay_state){

                            this.finish()
                        }else {
                            if (this.pollingTimer===-1){
                                this.pollingTimer = setInterval(()=>{
                                    func()
                                },500)
                            }
                        }
                    })
                }
                func()
            },

            finish(){

                if (this.pollingTimer>-1){
                    this.$message.success({
                        showClose: true,
                        message:'支付成功！'
                    })

                    this.pollingTimer>-1&&clearInterval(this.pollingTimer)
                    this.$emit('success')
                    this.$emit('close', false)
                    this.$route.path!=='/order'&&this.$router.push({
                        path: '/order',
                    })
                }

            },




        }
    }
</script>

<style scoped>
  .mask{
    background-color: rgba(0,0,0,0.4);

    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    z-index: 1000;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin: 0;
  }
  .dialog{
    width: 40%;
    background-color:white ;
    display: flex;
    align-items: center;
    flex-direction: column;
    border-radius: 4px;

  }
  .title{
    width: 95%;padding-left: 5%;display: flex;justify-content: space-between;align-items: center;
    font-size: 14px;color: #35315C;border-bottom: 1px dashed rgba(53,42,92,0.4);
    font-weight: 600;
  }

  .content{
    padding: 0 8% 20px 8%;
    display: flex;
    flex-direction: column;
    width:85% ;
  }
  .tip{
    background-color: #FFFBE6;
    border-radius: 4px;
    border: 1px solid #FFE58F;
    font-size: 12px;
    width: 100%;
    margin: 15px 0;
    display: flex;
    align-items: center;
    padding: 8px 0;
  }

  .item{
    width: 100%;
    margin-top: 15px;
    display: flex;
    align-items: center;
  }
  .item-label{
    font-size: 12px;
    color: #35315C;
    width: 20%;
    line-height: 40px;
    font-weight: 600;
  }
  .item-content{
    width: 75%;
    display: flex;
  }

  .pay-way-btn{
    width: 132px;
    height: 44px;
    border-radius: 4px;
    border:1px solid rgba(53,49,92,0.2);
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;


  }
  .pay-way-btn-active{
    width: 132px;
    height: 44px;
    border-radius: 4px;
    border:1px solid #4B00A4;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;


  }
  .price{
    font-size: 17px;color: #FF7BAC;line-height: 30px
  }


</style>
